import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {getCart} from '../../services/Cart/reducer';
import {useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../reducers";
import Money from "../Common/Money";
import {getSession} from "../../services/Session/reducer";
import {OrderType} from "../../services/Api/types";

interface OwnProps {
    goToCart: () => void
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const CartSummaryDataComponent = (props: Props) => {
    const cart = props.cart;
    const {t} = useTranslation();

    const renderDiscountMoney = () => {
        if (!cart || !cart.discount_money || cart.discount_money.amount === 0) {
            return null;
        }
        return (
            <dl>
                <dt>
                    {t("common.word.discount")}
                </dt>
                <dd className={"text-success"}>
                    -<Money value={cart.discount_money}/>
                </dd>
            </dl>
        )
    }

    const renderDeliveryInfo = () => {
        if (cart.type !== OrderType.DELIVERY)  return <></>;

        return (
            <dl>
                <dt>
                    {t("common.word.delivery")}
                </dt>
                <dd>
                    {cart.delivery_fee && cart.delivery_fee.amount === 0 ? (
                        <span className="text-success">{t("common.word.free_female")}</span>
                    ) : (
                        <Money value={cart.delivery_fee}/>
                    )}
                </dd>
            </dl>
        );
    }

    return (
        <div className={"cart-summary"}>
            <dl>
                <dt>
                    {t("common.word.summary_items")}
                </dt>
                <dd>
                    <Money value={cart.items_price}/>
                </dd>
            </dl>
            {renderDiscountMoney()}
            {renderDeliveryInfo()}
            {cart.promotions.filter((x:any) => x.type === "TIP").map(x => {
                return (
                    <dl key={x.id}>
                        <dt>
                            {x.name}
                        </dt>
                        <dd>
                            <Money value={x.value_money}/>
                        </dd>
                    </dl>
                )
            })}
            {cart.promotions.filter((x:any) => x.type === "TIP_MANUALLY").map(x => {
                return (
                    <dl key={x.id}>
                        <dt>
                            {t("common.word.tip")}
                        </dt>
                        <dd>
                            <Money value={x.value_money}/>
                        </dd>
                    </dl>
                )
            })}
            <div className="separator"></div>
            <dl className={"total"}>
                <dt>{t("common.word.sum")}</dt>
                <dd>
                <Money value={cart.total}/>
                </dd>
            </dl>
        </div>
    )
}


const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session),
    cart: getCart(state.cart)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartSummaryDataComponent));